import { render, staticRenderFns } from "./PricePartsImageSelectionModal.vue?vue&type=template&id=64df6b95&scoped=true"
import script from "./PricePartsImageSelectionModal.vue?vue&type=script&lang=js"
export * from "./PricePartsImageSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./PricePartsImageSelectionModal.vue?vue&type=style&index=0&id=64df6b95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64df6b95",
  null
  
)

export default component.exports